import * as Sentry from '@sentry/react'
import { Navigate, Outlet } from 'react-router-dom'

const ProtectedRoute = () => {
  const checkIfUserIsAuth = () => {
    const token = localStorage.getItem('tokenCityHunt')

    if (!token) {
      return false
    }

    return true
  }

  if (!checkIfUserIsAuth()) {
    const error = new Error('Not authenticated!')
    Sentry.captureException(error)
    Sentry.setContext('Variables', {
      authenticated: checkIfUserIsAuth(),
      token: localStorage.getItem('tokenCityHunt'),
    })
  }

  return checkIfUserIsAuth() ? <Outlet /> : <Navigate to="/error" />
}

export default ProtectedRoute
